import { Component, HostListener, inject } from '@angular/core';
import { Tenant } from 'app/models/api/tenants';
import { LanguageService } from 'app/services/language.service';
import { ProfileStore } from 'app/state-management/profile/profile.store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ApplicationStore } from 'app/state-management/application/application.store';
import { CurrentTenantService, LogoutService } from '../../../standalone-core/features';
import { FormsModule } from '@angular/forms';
import { FngSelectComponent } from '@festo-ui/angular';
import { ClickOutsideDirective } from 'app/directives/click-outside.directive';
import { SelectedTenantPipe } from './selected-tenant.pipe';
import { GetTenantOptionsPipe } from './get-tenant-options.pipe';

@Component({
  selector: 'sma-web-user-pop-over',
  templateUrl: './user-pop-over.component.html',
  styleUrls: ['./user-pop-over.component.scss'],
  imports: [
    FormsModule,
    TranslateModule,
    FngSelectComponent,
    ClickOutsideDirective,
    SelectedTenantPipe,
    GetTenantOptionsPipe,
  ],
})
export class UserPopOverComponent {
  protected readonly languageService: LanguageService = inject(LanguageService);
  private readonly profileStore = inject(ProfileStore);
  private readonly logoutService: LogoutService = inject(LogoutService);
  private readonly translateService: TranslateService = inject(TranslateService);
  private readonly appStore: ApplicationStore = inject(ApplicationStore);
  private readonly currentTenantService: CurrentTenantService = inject(CurrentTenantService);

  protected readonly identity = this.profileStore.profile;

  profilePopOverVisible: boolean = false;

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent): void {
    if (this.profilePopOverVisible && event.key === 'Escape') {
      this.closePopOver();
    }
  }

  onTenantChange(tenant: Tenant, selectedTenant: Tenant | null): void {
    this.profilePopOverVisible = false;

    if (selectedTenant?.id === tenant.id) {
      const text: string = this.translateService.instant('PROFILE.MESSAGES.NO_CHANGES_FOR_TENANT');
      this.appStore.showSnack({ text, showClose: true });
    } else {
      this.appStore.clearCachedApiData();
      this.currentTenantService.switchTo(tenant.id);
    }
  }

  openPopOver(event: Event): void {
    event.stopPropagation();
    this.profilePopOverVisible = !this.profilePopOverVisible;
  }

  closePopOver(): void {
    this.profilePopOverVisible = false;
  }

  onLogout(): void {
    this.logoutService.logout();
  }

  onLanguageChange(langKey: string): void {
    this.profilePopOverVisible = false;
    this.languageService.switchLanguage(langKey);
  }
}
